module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8015HD_white-d8081534edb2b35d1903ab8117e047a4.png";